import {GeneralLedgerSummaryApiDto} from "../../api/model/rest";

export default class GeneralLedgerSummary {

	constructor(public readonly credit: number,
		public readonly debit: number,
		public readonly netMovement: number) {}

	static fromJson(json: GeneralLedgerSummaryApiDto): GeneralLedgerSummary {
		return new GeneralLedgerSummary(json.credit, json.debit, json.netMovement);
	}
}
